export const HIDDEN_ISSUE_TYPE_CREATE_ISSUE = "HIDDEN_ISSUE_TYPE_CREATE_ISSUE";
export const HIDDEN_KUDO_TYPE_CREATE_KUDO = "HIDDEN_KUDO_TYPE_CREATE_KUDO";
export const HIDDEN_COMPANY_CREATE_VEHICLE = "HIDDEN_COMPANY_CREATE_VEHICLE"
export const HIDDEN_ASSOCIATE_ROSTER_STATUS_CREATE_ROUTE = 'HIDDEN_ASSOCIATE_ROSTER_STATUS_CREATE_ROUTE';
export const HIDDEN_PHOTO_LOG_TYPE_CREATE_VEHICLE_PHOTO_LOG = 'HIDDEN_PHOTO_LOG_TYPE_CREATE_VEHICLE_PHOTO_LOG';
export const HIDDEN_ROUTE_START_TIME_CREATE_ROUTE = 'HIDDEN_ROUTE_START_TIME_CREATE_ROUTE';